
import { CommonService } from '@/services'
import { ElForm } from 'element-ui/types/form'
import RowItem from '@/components/detail/row_item/index.vue'
import { Component, Vue, Ref } from 'vue-property-decorator'

const PageTypeName = {
    CreateSettingBulletin: 'Create',
    SettingBulletinDetail: 'Detail'
}

const ButtonText = {
    Create: '新增',
    Detail: '更新'
}

const data = {
    pageType: ''
}

@Component({
    name: 'bulletinDetail',
    components: {
        RowItem
    }
})
export default class extends Vue {
    @Ref('form') private formEl!: ElForm
    private bulletinId = ''
    private form = {
        url: '',
        title: '',
        abstract: '',
        content: '',
        published_at: ''
    }
    private formRules = {
        title: {
            required: true, message: '该项为必填', trigger: 'blur'
        },
        abstract: {
            required: true, message: '该项为必填', trigger: 'blur'
        },
        url: {
            type: 'url', message: '请输入正确的链接地址', trigger: 'blur'
        },
        published_at: {
            required: true, message: '该项为必填', trigger: 'blur'
        }
    }
    private isLoading = false
    private buttonLoading = false

    get buttonText() {
        return Reflect.get(ButtonText, data.pageType) || false
    }

    private created() {
        this.matchQuery()
    }

    private mounted() {
        this.getDetail()
    }

    /** 创建通告栏工单 */
    private async create() {
        const params = { ...this.form }
        const result = await CommonService.createBulletin(params)
        this.buttonLoading = false
        if (result.status === 200) {
            this.formEl.resetFields()
            this.$message({
                type: 'success',
                message: '创建成功',
                showClose: true
            })
            return
        }
        this.$message({
            type: 'error',
            message: result.message || '发生错误, 请稍后再试',
            showClose: true
        })
    }

    /** 更新数据 */
    private async update() {
        const params = {
            id: +this.bulletinId,
            ...this.form,
            created_at: undefined,
            updated_at: undefined
        }
        const result = await CommonService.updateBulletin(params)
        this.buttonLoading = false
        if (result.status === 200) {
            this.$message({
                type: 'success',
                message: '更新成功',
                showClose: true
            })
            return
        }
        this.$message({
            type: 'error',
            message: result.message || '发生错误, 请稍后再试',
            showClose: true
        })
    }

    /** 获取详情 */
    private async getDetail() {
        if (!this.bulletinId) return
        this.isLoading = true
        const params = { id: +this.bulletinId }
        const result = await CommonService.getBulletinDetail(params)
        if (result.status === 200) {
            this.form = { ...result.data }
        }
        this.isLoading = false
    }

    private matchQuery() {
        const { name, params } = this.$route
        const pageType = Reflect.get(PageTypeName, name!)
        data.pageType = pageType
        // 如果是详情或者更新
        if (['Detail'].includes(data.pageType)) {
            this.isLoading = true
        }
        this.bulletinId = params.id
    }

    private onCreate() {
        this.formEl.validate((isValid: boolean) => {
            if (!isValid) return
            this.buttonLoading = true
            if (data.pageType === 'Create') {
                this.create()
            } else {
                this.update()
            }
        })
    }
}
